import { FONT_WEIGHT } from '../../foundations/typography';
import { TagVariantType, TextVariantType } from '../variants';
export const parentContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    width: '100%',
    height: 'auto',
    display: 'flex',
    padding: `${FOUNDATIONS.spacing_250}`,
    position: 'relative',
});
export const dataContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    width: '100%',
    height: 'auto',
    display: 'flex',
    flex_direction: 'row',
    gap: FOUNDATIONS.spacing_250,
});
export const lineSeparatorCommonStyles = (FOUNDATIONS, FONT) => ({
    position: 'absolute',
    left: FOUNDATIONS.spacing_250,
    right: FOUNDATIONS.spacing_250,
    bottom: '0',
    border_bottom_style: 'solid',
    border_bottom_width: '1px',
    border_bottom_color: FOUNDATIONS.color_comp_tableslist_lineseparator_regular_border,
});
export const avatarContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    align_items: 'flex-start',
});
export const elementsContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    column_gap: FOUNDATIONS.spacing_100,
    flex: '1',
});
export const infoContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    flex_direction: 'column',
    row_gap: FOUNDATIONS.spacing_100,
    flex: '1',
    justify_content: 'center',
});
export const amountContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    flex_direction: 'column',
    row_gap: FOUNDATIONS.spacing_100,
    align_items: 'flex-end',
});
export const tagCommonStyles = (FOUNDATIONS, FONT) => ({
    variant: TagVariantType.ERROR,
});
export const titleCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_250,
    font_weight: FONT_WEIGHT.font_weight_600,
    color: FOUNDATIONS.color_neutral_font_50,
});
export const contentSubtitleCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_500,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_neutral_font_100,
});
export const subtitleCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_500,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_neutral_font_100,
});
export const amountCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_250,
    font_weight: FONT_WEIGHT.font_weight_600,
    color: FOUNDATIONS.color_neutral_font_50,
});
export const amountSubtitleCommonStyles = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_500,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_neutral_font_100,
});
export const selectorContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    align_items: 'center',
});
export const inputCommonStyles = (FOUNDATIONS, FONT) => ({
    position: 'absolute',
    left: '0px',
    top: '0px',
    right: '0px',
    bottom: '0px',
    cursor: 'pointer',
});
//# sourceMappingURL=commonStyles.js.map